module.exports = __webpack_public_path__ + "static/img/aboutcom.6b82690.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/aboutcom.jpg
// module id = sdn1
// module chunks = 1